/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 42,
    height: 42,
    viewBox: '0 0 42 42',
    data: '<path pid="0" d="M22.096 20.34h10.308c.605 0 1.096.447 1.096 1 0 .552-.49 1-1.096 1H9.596c-.605 0-1.096-.448-1.096-1 0-.553.49-1 1.096-1h12.5zM22.096 28.532h10.308c.605 0 1.096.448 1.096 1 0 .553-.49 1-1.096 1H9.596c-.605 0-1.096-.447-1.096-1 0-.552.49-1 1.096-1h12.5zM22.096 12.147h10.308c.605 0 1.096.447 1.096 1 0 .552-.49 1-1.096 1H9.596c-.605 0-1.096-.448-1.096-1 0-.553.49-1 1.096-1h12.5z" _fill="#FFD300"/>'
  }
})
